module.exports = __webpack_public_path__ + "../resources/img/ic_flashlight_off_default.94cf6f42.svg";